export const constants = {
  storageCredentials: 'credentials'
};
